<div class="carousel-container">
  <div class="slides">
    <img
      [src]="slides[currentIndex]['image']"
      (click)="openDialog(currentIndex)"
    />
  </div>
</div>
